var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img"},[_c('el-image',{attrs:{"src":("https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/certificate/" + _vm.id + ".png"),"fit":"contain"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }